import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallRefunded({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={8} cy={8} r={8} fill="#475E9F" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.52 7.39L7 4.76c.16-.1.33-.21.54-.21.43 0 .8.37.8.8 0 .22-.1.43-.26.6L6.93 7.16h4.02c.43 0 .8.38.8.8 0 .44-.38.81-.8.81H6.93l1.15 1.27c.16.16.26.38.26.6 0 .42-.37.8-.8.8a.69.69 0 01-.54-.22L4.52 8.57a.86.86 0 01-.27-.6c0-.2.1-.42.27-.58z"
        fill="#fff"
      />
    </svg>
  );
}

SvgTickSmallRefunded.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallRefunded.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickSmallRefunded svgRef={ref} {...props} />
));
export default ForwardRef;
